import { forEach, remove, every, isEmpty, isFinite } from "lodash";

const hasNoVisibleTotals = (grouping) =>
  isEmpty(grouping.summedTotals) ||
  every(grouping.summedTotals, (total) => total.total === 0);

const hasNoVisibleRows = (grouping) =>
  grouping.childGroupings.length === 0 && grouping.lineItems.length === 0;

const isEmptyDemandRollupContextGrouping = (grouping) =>
  grouping.isDemandRollupContext &&
  hasNoVisibleRows(grouping) &&
  hasNoVisibleTotals(grouping);

export const pruneEmptyGroupings = (groupings, isBudgetEnabled) => {
  forEach(groupings, (grouping) => {
    pruneEmptyGroupings(grouping.childGroupings, isBudgetEnabled);

    grouping.canToggleLineItems =
      !isEmpty(grouping.childGroupings) &&
      (!isEmpty(grouping.lineItems) > 0 || grouping.canAddLineItem);
  });

  remove(groupings, (g) => {
    if (isBudgetEnabled && isFinite(g.budget)) {
      return false;
    }
    if (g.isDemandRollupContext) {
      return false;
    }
    return (
      (g.childGroupings.length === 0 && g.lineItems.length === 0) ||
      (g.memberCount === 0 && every(g.summedTotals, (t) => t.total === 0))
    );
  });
};

export const pruneEmptyDemandRollupContextGroupings = (groupings) => {
  forEach(groupings, (grouping) => {
    pruneEmptyDemandRollupContextGroupings(grouping.childGroupings);
  });

  remove(groupings, isEmptyDemandRollupContextGrouping);
};

export const pruneEmptyConstraintGroupings = (groupings) => {
  forEach(groupings, (grouping) => {
    pruneEmptyConstraintGroupings(grouping.childGroupings);

    grouping.canToggleLineItems =
      !isEmpty(grouping.childGroupings) &&
      (!isEmpty(grouping.lineItems) > 0 || grouping.canAddLineItem);
  });

  remove(
    groupings,
    (g) => g.memberCount === 0 && every(g.summedTotals, (t) => t.total === 0)
  );
};
